import Vue from 'vue'

const entityAddress = {
  state: {
    entityAddress: [],
    selectedEntityAddress: {},
  },

  getters: {
    entityAddress(state) {
      return state.entityAddress
    },
    selectedEntityAddress(state) {
      return state.selectedEntityAddress
    },
  },

  mutations: {
    entityAddress(state, payload) {
      state.entityAddress = payload
    },
    selectedEntityAddress(state, payload) {
      state.selectedEntityAddress = JSON.parse(JSON.stringify(payload))
    },
  },

  actions: {
    setSelectedEntityAddress(context, payload) {
      context.commit('selectedEntityAddress', payload)
    },
    loadEntityAddress(context, payload) {
      return new Promise((resolve, reject) => {
        const url = 'EntityAddress'
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('entityAddress', res.data)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    loadSelectedEntityAddress(context, payload) {
      return new Promise((resolve, reject) => {
        const url = 'EntityAddress/' + payload
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('selectedEntityAddress', res.data)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    updateEntityAddress(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `EntityAddress/${payload.ID}`
        Vue.prototype.$axios.put(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              {color: 'success', message: 'address updated'},
              {root: true}
            )
            //if you will always need to reload the list after an update
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadEntityAddress')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    createEntityAddress(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `EntityAddress`
        Vue.prototype.$axios.post(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              {color: 'success', message: 'address created'},
              {root: true}
            )
            //if you will always need to reload the list after an item is created
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadEntityAddress')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    saveEntityAddress(context, payload) {
      return new Promise((resolve, reject) => {
        if (payload.ID > 0) {
          context.dispatch('updateEntityAddress', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        } else {
          context.dispatch('createEntityAddress', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        }
      })
    },
    deleteEntityAddress(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `EntityAddress/${payload.ID}`
        Vue.prototype.$axios.delete(url).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              {color: 'success', message: 'address deleted'},
              {root: true}
            )
            //if you will always need to reload the list after a delete
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadEntityAddress')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
  },
}

export default entityAddress
